import { EntitySchema } from '@camberi/firecms';

export interface SmsNotification {
  toGroup: string[];
  category: string;
  body: string; // Markdown.
  delivery?: {
    state: string;
  };
  recipientCount: number;
  dateCreated: any;
  dateUpdated: any;
}

export default {
  name: 'SMS Notficiation',
  properties: {
    toGroup: {
      dataType: 'array',
      title: 'To',
      validation: { required: true },
      description: 'Pick the groups you want to sms',
      of: {
        dataType: 'string',
        config: {
          enumValues: {
            partner: 'Partners',
            admin: 'Admins',
            applicant: 'Applicants',
            alipesTest: 'Alipes Test',
          },
        },
      },
    },
    category: {
      title: 'Category',
      dataType: 'string',
      validation: { required: true },
      description: 'Pick the type of sms. Some users may have one or both disabled.',
      config: {
        enumValues: {
          marketing: 'Marketing',
          important: 'Important',
        },
      },
    },
    body: {
      title: 'Body',
      dataType: 'string',
      validation: { required: true },
    },
    recipientCount: {
      title: 'Recipient Count',
      dataType: 'number',
      disabled: true,
    },
    dateCreated: {
      title: 'Date Created',
      dataType: 'timestamp',
      autoValue: 'on_create',
      disabled: {
        hidden: true,
      },
    },
    dateUpdated: {
      title: 'Date Updated',
      dataType: 'timestamp',
      autoValue: 'on_update',
      disabled: {
        hidden: false,
      },
    },
  },
} as EntitySchema<SmsNotification>;
